import script from "./TrocarEpModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TrocarEpModal.vue?vue&type=script&setup=true&lang=js"

import "./TrocarEpModal.vue?vue&type=style&index=0&id=2e7407c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e7407c6"]])

export default __exports__